import { FC, SVGProps } from "react";
import { classNames } from "primereact/utils";
import { MS_ICON_SIZE_MAP, TMsIconName, TMsIconSize, TMsIconType } from "./iconMap";
import { MS_STYLED_ICON_MAP } from "./index.styled";

export interface IMsIconProps extends SVGProps<SVGSVGElement> {
  name: TMsIconName;
  type?: TMsIconType;
  size?: TMsIconSize;
}

export const MsIcon: FC<IMsIconProps> = ({
  name,
  size = "M",
  type = "info",
  className,
  ...rest
}) => {
  const StyledComponent = MS_STYLED_ICON_MAP[name];
  const sizeValue = getSize(size);

  const defaultProps: Partial<SVGProps<SVGSVGElement>> = {
    width: sizeValue,
    height: sizeValue,
    strokeWidth: 1.5
  };

  return (
    <StyledComponent
      {...defaultProps}
      {...rest}
      aria-label={`ms-icon-${name}`}
      className={classNames("ms-icon", type, className)}
    />
  );
};

function getSize(size: TMsIconSize) {
  if (typeof size === "number") {
    return size;
  } else {
    return MS_ICON_SIZE_MAP[size];
  }
}
